import React from 'react';
import PropTypes from 'prop-types';

const Paper = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="1" width="14.8235" height="18" rx="2" stroke={color} strokeWidth="2" />
    <path d="M5.73438 6.29395H12.0873" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M5.73438 10.5293H12.0873" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M5.73438 14.7646H9.96967" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

Paper.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Paper;
